import { useState, type FormEvent } from 'react';
import { submitForm } from '@/lib/submitForm';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/db4rqg9rqll58fj4oal0';

export default function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    setStatus('loading');
    setMessage('');

    const outcome = await submitForm(form, SUBMIT_ADDR, 'company_alt');
    if (outcome.ok) {
      setStatus('success');
      setMessage('提交成功！我们会尽快通过邮箱与你联系。');
      form.reset();
    } else {
      setStatus('error');
      setMessage(outcome.message || '提交失败，请稍后重试。');
    }
  };

  return (
    <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
      <input
        type="text"
        name="company_alt"
        className="subscribe-guard-field"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />
      <div>
        <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">称呼</label>
        <input
          id="contact-name"
          name="name"
          type="text"
          required
          placeholder="请输入你的称呼"
          className="w-full rounded-md border border-background-300 focus:border-primary-400 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none transition-colors"
        />
      </div>
      <div>
        <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">邮箱</label>
        <input
          id="contact-email"
          name="email"
          type="email"
          required
          placeholder="请输入你的邮箱地址"
          className="w-full rounded-md border border-background-300 focus:border-primary-400 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none transition-colors"
        />
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">留言内容</label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={4}
          placeholder="请描述你的问题、建议或合作意向（最多 500 字）"
          className="w-full resize-none rounded-md border border-background-300 focus:border-primary-400 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none transition-colors"
        ></textarea>
      </div>
      <button
        type="submit"
        disabled={status === 'loading'}
        className="cursor-pointer whitespace-nowrap w-full bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-white text-sm font-medium px-6 py-3 rounded-full transition-colors"
      >
        {status === 'loading' ? '提交中…' : '提交留言'}
      </button>
      {message && (
        <p className={`text-sm rounded-md px-4 py-2.5 ${status === 'success' ? 'text-accent-900 bg-accent-100' : 'text-primary-800 bg-primary-100'}`}>
          {message}
        </p>
      )}
    </form>
  );
}